import { uniq } from "lodash-es";

/*
  Use this instead of delete operator when you want to delete a property from an object immutably.
 */
export const immutableDeleteProperty = (
  obj: Record<string, any> | null,
  propertyName: string
) => {
  if (!obj) {
    return obj;
  }
  const newObject = { ...obj };

  if (newObject[propertyName] && delete newObject[propertyName]) {
    return newObject;
  }

  return obj;
};

/**
 * Merge two string array maps
 * @param map1 - The first map
 * @param map2 - The second map
 * @returns A merged map
 */
export const mergeStringArrayMaps = (
  map1: Record<string, string[]> | undefined,
  map2: Record<string, string[]> | undefined
) => {
  if (!map2) {
    return map1;
  } else if (!map1) {
    return map2;
  }

  // get unique keys
  const uniqueGroupNames = uniq([...Object.keys(map1), ...Object.keys(map2)]);

  // run through unique keys and merge values
  return uniqueGroupNames.reduce((acc: Record<string, string[]>, groupName) => {
    acc[groupName] = uniq([
      ...(map1[groupName] ?? []),
      ...(map2[groupName] ?? [])
    ]);
    return acc;
  }, {});
};
